/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_4_SolutionInputs */

const es_home_usecases_item_4_solution = /** @type {(inputs: Home_Usecases_Item_4_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscá: 'preparación reunión cliente ABC de mañana'. Obtenés: Documentos relevantes, emails y notas previas.`)
};

const en_home_usecases_item_4_solution = /** @type {(inputs: Home_Usecases_Item_4_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search: 'preparation for ABC client meeting tomorrow'. Get: Relevant documents, emails, and previous notes.`)
};

/**
* | output |
* | --- |
* | "Search: 'preparation for ABC client meeting tomorrow'. Get: Relevant documents, emails, and previous notes." |
*
* @param {Home_Usecases_Item_4_SolutionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_4_solution = /** @type {((inputs?: Home_Usecases_Item_4_SolutionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_4_SolutionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_4_solution(inputs)
	return en_home_usecases_item_4_solution(inputs)
});
export { home_usecases_item_4_solution as "home.usecases.item_4_solution" }